/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'personal-address',
  template: require('./personal-address.component.html')
})
export class PersonalAddressComponent extends BaseRoute {

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    const steps = this.flowManager.getStepArrays('personal-address');
    this.form.stepsComplete = steps.stepsComplete;
    this.form.stepsToComplete = steps.stepsToComplete;

    if (this.flowManager.isAuthed) {
      this.form.buttons.inputs.back.path = '/personal-info-auth';

      if (this.flowManager.isTkCustomer === true) {
        this.form.buttons.inputs.next.path = '/employment-info';
      }
    }
  }

  btnClick(e) {
    this.handleClick(e.action);
  }
}
